import { isValid, startOfDay } from 'date-fns'
import { isEmpty } from 'lodash'
import type {
  ExperimentVariable,
  TextFeatureVariable,
  UrgencyFeatureVariable,
  UrgencyVariableKey,
  UrgencyVariableName,
} from '../types'

// matches yyyy-MM-ddTHH:mm:SSZ format
const YYYY_MM_DD_T_HH_MM_SS_Z_REGEX = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/

export const getUrgencyVariableForDate = ({
  variableName,
  variableKey,
  variables,
}: {
  variableName: UrgencyVariableName
  variableKey: UrgencyVariableKey
  variables?: ExperimentVariable
}) => {
  let returnValue: TextFeatureVariable = ''

  const urgencyTexts = variables?.[variableName] as UrgencyFeatureVariable
  if (isEmpty(urgencyTexts)) return returnValue

  let closestDateDiff: number | undefined

  for (const [_, values] of Object.entries(urgencyTexts)) {
    const dateStr = values.available_from
    const parsedDate = Date.parse(dateStr)

    if (dateStr && isValid(parsedDate)) {
      let diff
      if (YYYY_MM_DD_T_HH_MM_SS_Z_REGEX.test(dateStr)) {
        diff = new Date().getTime() - parsedDate
      } else {
        diff = startOfDay(new Date()).getTime() - parsedDate
      }

      if (diff >= 0) {
        const text = values[variableKey]
        if (diff === 0) return text

        closestDateDiff = closestDateDiff || diff

        if (diff <= closestDateDiff) {
          closestDateDiff = diff
          returnValue = text
        }
      }
    }
  }

  return returnValue
}
